


import { Twiggy as TwiggyClient } from './core/client';
export { TwiggyClient as Twiggy };


export type {
  TwiggyConfig,
  TwiggyStorePlatform,
  TrackingEventType,
  ConsentCategory,
  AutoCaptureType,
  CartItem,
  EventProperties,
  EventContext,
  TrackingEvent,
  IdentifyData,
  ProductViewData,
  AddToCartData,
  RemoveFromCartData,
  CheckoutStepData,
  SearchData,
  TrackResponse,
  IdentifyResponse,
  ConsentResponse
} from './types';


export { SessionManager } from './identity/session';
export { VisitorManager } from './identity/visitor';
export { ConsentManager } from './identity/consent';


export { AutoCapture } from './tracking/auto-capture';
export {
  EcommerceTracker,
  setupVtexIntegration,
  setupGtagIntegration,
  setupVtexCartAbandonmentTracking,
  ensureVtexCartAbandonmentTracking,
  setupVtexCartAbandonmentTrackingWithPoll,
  setupDataLayerLeadCapture,
  setupDataLayerWishlistCapture
} from './tracking/ecommerce';


export { generateId, getCookie, setCookie } from './utils/storage';


export { TwiggyProvider, useTracking, useTwiggy } from './react';


let globalInstance: TwiggyClient | null = null;


export function init(config: import('./types').TwiggyConfig): TwiggyClient {
  globalInstance = new TwiggyClient(config);
  return globalInstance;
}


export function getInstance(): TwiggyClient | null {
  return globalInstance;
}


if (typeof window !== 'undefined') {
  const win = window as unknown as {
    TwiggyQueue?: Array<[string, ...unknown[]]>;
    twiggy?: Record<string, (...args: unknown[]) => void>;
  };

  
  if (win.TwiggyQueue && Array.isArray(win.TwiggyQueue)) {
    win.TwiggyQueue.forEach(([method, ...args]) => {
      if (
        globalInstance &&
        typeof (globalInstance as unknown as Record<string, unknown>)[method] === 'function'
      ) {
        (globalInstance as unknown as Record<string, (...args: unknown[]) => void>)[method](
          ...args
        );
      }
    });
  }

  
  if (win.twiggy) {
    win.twiggy.track = (...args: unknown[]) =>
      globalInstance?.track(args[0] as string, args[1] as import('./types').EventProperties);
    win.twiggy.identify = (...args: unknown[]) =>
      globalInstance?.identify(args[0] as import('./types').IdentifyData);
    win.twiggy.pageView = (...args: unknown[]) =>
      globalInstance?.pageView(args[0] as import('./types').EventProperties);
    win.twiggy.productView = (...args: unknown[]) =>
      globalInstance?.productView(args[0] as import('./types').ProductViewData);
    win.twiggy.addToCart = (...args: unknown[]) =>
      globalInstance?.addToCart(args[0] as import('./types').AddToCartData);
    win.twiggy.removeFromCart = (...args: unknown[]) =>
      globalInstance?.removeFromCart(args[0] as import('./types').RemoveFromCartData);
    win.twiggy.checkoutStep = (...args: unknown[]) =>
      globalInstance?.checkoutStep(args[0] as import('./types').CheckoutStepData);
    win.twiggy.search = (...args: unknown[]) =>
      globalInstance?.search(args[0] as import('./types').SearchData);
    win.twiggy.ensureVtexCartAbandonment = () => globalInstance?.ensureVtexCartAbandonment();
  }
}


export default { init, getInstance };
